import OurClientList from '@/Components/About/OurClientList'

import logo1 from 'public/Our_clients/clientLogo1.png'
import logo2 from 'public/Our_clients/clientLogo2.webp'
import logo3 from 'public/Our_clients/clientLogo3.webp'
import logo4 from 'public/Our_clients/clientLogo4.webp'
import logo6 from 'public/Our_clients/clientLogo6.webp'
import logo5 from 'public/Our_clients/clientLogo7.webp'

import bg1 from 'public/Our_clients/clientBg1.png'
import bg2 from 'public/Our_clients/clientBg2.webp'
import bg3 from 'public/Our_clients/clientBg3.webp'
import bg4 from 'public/Our_clients/clientBg4.webp'
import bg5 from 'public/Our_clients/clientBg5.webp'
import bg6 from 'public/Our_clients/clientBg6.webp'

const clients = [
    // {
    //     clientName: 'BetsWap.gg',
    //     bg: bg1,
    //     clientLogo: logo1,
    //     hashTag: 'devops #blockchain #web3',
    //     country: 'UAE',
    //     description:
    //         'Betswap is a  betting platform which offers virtual games and live sports betting for real money.',
    //     link: 'case-studies/betswap',
    // },
    {
        clientName: 'ICSI',
        bg: bg1,
        clientLogo: logo1,
        hashTag: 'devops',
        country: 'INDIA',
        description:
            'Cloudastra Technologies develops digital education solutions that have transformed professional training at ICSI (Institute of Company Secretaries of India). Their platform improves the learning experience and resource accessibility for company secretary students while making administrative processes more efficient.',
        link: 'case-studies/icsi',
    },
    {
        clientName: 'FreeCast',
        bg: bg2,
        clientLogo: logo2,
        hashTag: 'devops',
        country: 'USA',
        description:
            'Freecast is a US based OTT platform which brings you daily entertainment on your fingertips.',
        link: 'case-studies/freecast',
    },
    {
        clientName: 'ICE',
        bg: bg3,
        clientLogo: logo3,
        hashTag: 'devops #blockchain #web3',
        country: 'USA',
        description:
            'ICE network is blockchain network designed on top of substrate to support nextgen web3 technologies.',
        link: 'case-studies/ice',
    },
    {
        clientName: 'POLITECH',
        bg: bg4,
        clientLogo: logo4,
        hashTag: 'devops',
        country: 'USA',
        description:
            'Politech is a web application based for productivity enhancement project based on pearl.',
        link: 'case-studies/politech',
    },
    {
        clientName: 'MHP',
        bg: bg5,
        clientLogo: logo5,
        hashTag: 'devops',
        country: 'USA',
        description:
            'My Home Pathway is a platform that uses technology to assist first-time home buyers in getting approved more quickly.',
        link: 'case-studies/mhp',
    },
    {
        clientName: 'Tompkins Robotics',
        bg: bg6,
        clientLogo: logo6,
        hashTag: 'devops',
        country: 'USA',
        description:
            'Tompkins is a US based robotics automation solutions company which enhances B2B solutions.',
        link: 'case-studies/tompkins',
    },
]
export default function OurClients() {
    return (
        <div>
            <OurClientList clients={clients} />
        </div>
    )
}
